import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConvexProvider } from './app/providers/ConvexProvider';
import { AppShell } from './app/layout/AppShell';
import './styles/globals.css';

const root = document.getElementById('root');

if (!root) {
    throw new Error('Root element not found');
}

createRoot(root).render(
    <StrictMode>
        <BrowserRouter>
            <ConvexProvider>
                <AppShell />
            </ConvexProvider>
        </BrowserRouter>
    </StrictMode>
);
